import { CSSProperties, ReactNode } from 'react';
import cl from 'clsx';

import { Checkbox2Props, Checkbox2 } from '@/true-fsd/shared/ui/Checkbox2';

import classes from './CreateInvite.Content.module.scss';

export type LabeledCheckBoxProps = Pick<
  Checkbox2Props,
  'checked' | 'onCheckedChange' | 'disabled'
> & {
  children: ReactNode;
  style?: CSSProperties;
};
export const LabeledCheckBox = ({
  children,
  style,
  ...checkboxProps
}: LabeledCheckBoxProps) => {
  return (
    <label
      className={cl(classes.label, {
        [classes.disabled]: checkboxProps.disabled,
      })}
      style={style}
    >
      <Checkbox2 {...checkboxProps} />
      <div className={cl(classes.text)}>{children}</div>
    </label>
  );
};
